<template>
  <div class="calendar-sidebar bg-white p-3 mr-3 shadow-sm rounded">
    <h6 class="text-secondary">Empleados</h6>
    <slot name="filter"></slot>
  </div>
</template>

<script>
export default {
  name: 'CalendarSidebar'
};
</script>

<style scoped>
.calendar-sidebar {
  width: 240px;
  background-color: #fff;
}
.calendar-sidebar h6 {
  margin-bottom: 0.75rem;
  font-size: 0.9rem;
}
</style>